/*eslint-disable*/
import React from 'react'
import { Form as FormUi, Container, Button, Label, Modal,Grid , Divider,Header,Icon} from 'semantic-ui-react';
import {vendor_branch} from './vendorConstants'


const AddVendorBranchDetailsModal = ({ handleCloseBranchDetails, data }) => {

    return (
        <>             
            <Modal.Content>
                <Container>
                <Grid columns={4} className="ml-2">
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.branch||"Branch"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName fixedLength150"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data?.vendorBranchName ? data.vendorBranchName  : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.state||"State"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName "
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data?.vendorBranchState ? data.vendorBranchState  : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.city||"City"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data?.vendorBranchCity ? data.vendorBranchCity  : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.pincode||"Pincode"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.vendorBranchPincode ? data.vendorBranchPincode : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                  <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.pan_no||"PAN Number"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data?.vendorBranchPAN ? data.vendorBranchPAN : "NA"}
                      </Header>
                    </Grid.Column>

                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.address||"Address"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName fixedLength150"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data?.vendorBranchAddress ? data.vendorBranchAddress : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Divider horizontal>
                        <Header as='h5'>
                        {vendor_branch?.titles?.bank_title||"Bank_Details"}
                        </Header>
                    </Divider>
                  <Grid.Row>
                  <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.bank_name||"Bank Name"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName fixedLength150"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data?.vendorBranchBankName ? data.vendorBranchBankName  : "NA"}
                      </Header>
                    </Grid.Column>
                  <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.account_no||"Account Number"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data?.vendorBranchAccountNumber? data.vendorBranchAccountNumber  : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.account_holder||"Account Holder Name"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName fixedLength150"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data?.vendorBranchBankAccountHolder ? data.vendorBranchBankAccountHolder : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.ifsc||"IFSC Code"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data?.vendorBranchBankIFSC ? data.vendorBranchBankIFSC  : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                 
                  <Divider horizontal>
                        <Header as='h5'>
                        {vendor_branch?.titles?.gst_title||"GST_Details"}
                        </Header>
                    </Divider>
                  <Grid.Row>
                  <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.is_gst_applicable||"Is GST Applicable"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data?.isGSTApplicable ? "Yes" : "No"}
                      </Header>
                    </Grid.Column>

                  <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.gst_no||"GST Number"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.isGSTApplicable && data.vendorBranchGST ? data.vendorBranchGST  : "NA"}
                      </Header>
                    </Grid.Column>
                    
                  </Grid.Row>
                  <Grid.Row>
                  <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.start_date||"Validity Start Date"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data?.isGSTApplicable && data?.validityStartDate ? data.validityStartDate.split("-").reverse().join("-") : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.end_date||"Validity End Date"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data?.isGSTApplicable && data?.validatityEndDate ? data.validatityEndDate.split("-").reverse().join("-")  : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_branch?.headers?.charge_mechanism||"GST Charge Mechanism"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data?.isGSTApplicable && data?.gstChargeMechanism ? data.gstChargeMechanism : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                </Container>
            </Modal.Content>
            <Modal.Actions>
                <Button type="submit" onClick={handleCloseBranchDetails} size="mini" primary>{vendor_branch?.buttons?.ok||"Ok"}</Button>
            </Modal.Actions>
        </>
    )
}



export default AddVendorBranchDetailsModal
